import { render, staticRenderFns } from "./ShopPromotions.vue?vue&type=template&id=53c4fdb6&scoped=true&"
import script from "./ShopPromotions.vue?vue&type=script&lang=js&"
export * from "./ShopPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c4fdb6",
  null
  
)

export default component.exports